import classNames from 'classnames';

import ShoppingCartIcon from '@heroicons/react/20/solid/ShoppingCartIcon';
import { m } from 'framer-motion';
import { IconType } from '../../../constants';
import { ButtonType } from './ButtonType';
import { getButtonColorClasses, BUTTON_ANIMATION } from './constants';
import { ReactNode, useCallback } from 'react';
import { useTheme } from '../../../context/theme/useTheme';
import { ThemeSecondary } from '../../../context/theme/ThemeConstantsUpdated';

const { secondaryBackground } = ThemeSecondary;

export const NotificationButton = (props: Props) => {
  const { buttonType, notificationAmount, onClick } = props;
  const { isDarkMode } = useTheme();
  const buttonColorClasses = getButtonColorClasses({
    buttonType,
    isDarkMode,
  });
  const Icon = props.Icon || ShoppingCartIcon;
  const buttonClasses = classNames(
    buttonColorClasses,
    'relative rounded-full h-9 w-9 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'
  );
  const ButtonWrapper = useCallback(
    ({ children }: { children: ReactNode }) =>
      onClick == null ? (
        <m.div className={buttonClasses} {...BUTTON_ANIMATION}>
          {children}
        </m.div>
      ) : (
        <m.button className={buttonClasses} {...BUTTON_ANIMATION} onClick={() => onClick()}>
          {children}
        </m.button>
      ),
    [buttonClasses, onClick]
  );

  return (
    <ButtonWrapper>
      {notificationAmount === true ? (
        <span
          className={classNames(
            secondaryBackground,
            'absolute -right-0.5 -top-0.5 z-10 inline-flex h-3 w-3 rounded-full'
          )}
        />
      ) : (
        notificationAmount > 0 && (
          <div
            className={classNames(
              secondaryBackground,
              'absolute -right-2 -top-2 inline-flex h-[18px] w-[18px] rounded-full text-xs text-white'
            )}
          >
            <span className="abs-middle font-semibold">{notificationAmount}</span>
          </div>
        )
      )}
      <Icon className="abs-middle h-6 w-6" {...BUTTON_ANIMATION} />
    </ButtonWrapper>
  );
};

type Props = {
  buttonType?: ButtonType;
  onClick?: () => void;
  Icon?: IconType;
  notificationAmount: number | true;
};
